import React, { useState } from "react";
import PropTypes from "prop-types";
import { FT } from "./partnerPortalShared";

// Persistent referral sign-up link, shown as the first element of page content on
// every partner tab (identical slot), replacing the old header chip.
export default function ReferralStrip({ signupPageUrl, referralCode }) {
  const [copied, setCopied] = useState(false);

  const fullSignupUrl =
    signupPageUrl ||
    (referralCode
      ? `https://fundtap.co/partners/${referralCode.toLowerCase()}`
      : null);
  const shownUrl = fullSignupUrl
    ? fullSignupUrl.replace(/^https?:\/\//, "")
    : "fundtap.co/partners/your-code";

  const copyLink = () => {
    if (navigator.clipboard?.writeText && fullSignupUrl) {
      navigator.clipboard.writeText(fullSignupUrl).catch(() => {});
    }
    setCopied(true);
    setTimeout(() => setCopied(false), 1800);
  };

  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        gap: 16,
        background: "#fff",
        border: `1px solid ${FT.navy15}`,
        borderRadius: 10,
        padding: "10px 16px",
        marginBottom: 22,
        fontFamily: FT.font
      }}
    >
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: 10,
          fontSize: 13,
          fontWeight: 600,
          color: FT.navy80,
          minWidth: 0
        }}
      >
        <svg
          width="15"
          height="15"
          viewBox="0 0 24 24"
          fill="none"
          stroke={FT.navy60}
          strokeWidth="2"
          strokeLinecap="round"
        >
          <path d="M10 13a5 5 0 0 0 7.07 0l3-3a5 5 0 0 0-7.07-7.07l-1 1" />
          <path d="M14 11a5 5 0 0 0-7.07 0l-3 3a5 5 0 0 0 7.07 7.07l1-1" />
        </svg>
        <span style={{ whiteSpace: "nowrap" }}>Your sign-up link</span>
        <code
          style={{
            fontSize: 12.5,
            color: FT.navy,
            fontFamily: "ui-monospace, SFMono-Regular, Menlo, monospace",
            background: FT.navy04,
            padding: "4px 10px",
            borderRadius: 6,
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap"
          }}
        >
          {shownUrl}
        </code>
      </div>
      <button
        onClick={copyLink}
        style={{
          flex: "0 0 auto",
          height: 34,
          padding: "0 14px",
          background: copied ? FT.mintBg : "#fff",
          color: FT.navy,
          border: `1px solid ${copied ? FT.mint : FT.navy15}`,
          borderRadius: 10,
          fontSize: 12.5,
          fontWeight: 600,
          cursor: "pointer",
          fontFamily: "inherit",
          whiteSpace: "nowrap",
          transition: "all 0.15s"
        }}
      >
        {copied ? "Copied" : "Copy link"}
      </button>
    </div>
  );
}

ReferralStrip.propTypes = {
  signupPageUrl: PropTypes.string,
  referralCode: PropTypes.string
};
